import { Button, Card, Group, Stack, Text, Title } from '@mantine/core'
import { IconExternalLink } from '@tabler/icons-react'

interface ToolCardProps {
  title: string
  description: string
  href: string
  linkText: string
}

function ToolCard({ title, description, href, linkText }: ToolCardProps) {
  return (
    <Card withBorder>
      <Stack>
        <Title order={3}>{title}</Title>
        <Text c="dimmed">{description}</Text>
        <Group>
          <Button
            component="a"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            rightSection={<IconExternalLink size={16} />}
          >
            {linkText}
          </Button>
        </Group>
      </Stack>
    </Card>
  )
}

export function SqlServerLineage() {
  return (
    <Stack>
      <Title order={1}>Legacy Data Lineage</Title>
      <Text c="dimmed">
        Explore SQL Server metadata and legacy report lineage.
      </Text>
      <ToolCard
        title="SQL Server Metadata"
        description="Browse SQL Server instances, databases, tables, views, and columns."
        href="https://mra1964.ld.corp.local/"
        linkText="Open SQL Server metadata"
      />
      <ToolCard
        title="Legacy Report Lineage"
        description="View lineage for legacy reports and understand upstream dependencies."
        href="https://mango-dune-003687c1e.5.azurestaticapps.net/.auth/basicAuth/login"
        linkText="Open legacy report lineage"
      />
    </Stack>
  )
}
